import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BiFile } from 'react-icons/bi';
import { StyledButton } from './style';
import ReactLoading from 'react-loading';

const FileButton = ({ fileInputRef, label, attachNewFile }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = async e => {
    try {
      setIsLoading(true);
      await attachNewFile(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <StyledButton
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          opacity: isLoading ? 0.7 : 1,
        }}
        onClick={() => !isLoading && fileInputRef.current.click()}
        disabled={isLoading}
      >
        {isLoading ? (
          <ReactLoading type="spin" color="#011826" height={24} width={24} />
        ) : (
          <>
            <BiFile size={24} />
            <span style={{ marginLeft: '8px', fontSize: '1rem' }}>
              {label || 'ANEXAR ARQUIVO'}
            </span>
          </>
        )}
      </StyledButton>

      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </>
  );
};

FileButton.propTypes = {
  fileInputRef: PropTypes.object.isRequired,
  attachNewFile: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default FileButton;
